import { ReactNode } from 'react';

import { DrawerHeader as BaseDrawerHeader, Subhead, cn } from '@growtherapy/sprout-ui';

import { useTheme } from '../hooks/useTheme';
import { Theme } from '../state/theme';

type DrawerHeaderProps = Omit<Parameters<typeof BaseDrawerHeader>[0], 'children'>;
type SubheadProps = Omit<Parameters<typeof Subhead.Default>[0], 'children'>;

export function DrawerHeader({
  children,
  drawerHeaderProps,
  headingProps,
}: {
  children: ReactNode;
  drawerHeaderProps?: DrawerHeaderProps;
  headingProps?: SubheadProps;
}) {
  const { theme } = useTheme();
  const isDarkTheme = theme === Theme.DARK;

  return (
    <BaseDrawerHeader {...drawerHeaderProps}>
      <Subhead.Default
        as='h2'
        className={cn({
          'rebrand:text-text-inverse': isDarkTheme,
        })}
        {...headingProps}
      >
        {children}
      </Subhead.Default>
    </BaseDrawerHeader>
  );
}
